import { useMemo } from 'react';
import { useGET } from '../shared/hooks';
import { responseToSummary } from './lineupSummary';

const toUrl = (leagueId, seasonId, teamId) =>
  `/league/${leagueId}/team/${teamId}/lineups/summary?min_possessions=10&season_id=${seasonId}`;

export function useLineupSummary(leagueId, seasonId, teamId, pathTo) {
  const url = toUrl(leagueId, seasonId, teamId);
  const data = useGET(url);
  const summary = useMemo(() => responseToSummary(data, pathTo), [
    data,
    pathTo,
  ]);

  return summary;
}
